import { render, staticRenderFns } from "./LedgerAccounts.vue?vue&type=template&id=4adf34a8"
import script from "./LedgerAccounts.vue?vue&type=script&lang=js"
export * from "./LedgerAccounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports